import request from '../utils/request'

const prefix = "/courses";

/**
 * 课程列表
 * @param {
 *    page , per_page , depart_id , uid , position
 * } params
 * @returns
 */
export function getCourseList(params) {
    return request.get(`${prefix}`, {params});
}

// 课程详情
export function getCourseInfo(id) {
    return request.get(`${prefix}/${id}`, {});
}

// 获取课程，无购买状态
export function getGuestCourseInfo(id) {
    return request.get(`${prefix}/guest/${id}`, {});
}

// 课程购买下单
export function courseBuy(params) {
    return request.post(`${prefix}/buy`, params);
}

// 课程购买支付
export function coursePay(params) {
    return request.post(`${prefix}/pay`, params);
}

// 课程代付
export function courseCallToPay(params) {
    return request.post(`${prefix}/payment`, params);
}

// 我的课程订单
export function getCourseOrders() {
    return request.get(`${prefix}/orders`, {});
}

// 课程章节
export function getCourseMedias(params) {
    return request.get(`${prefix}/medias`, {params});
}

// 添加课程记录
export function addCourseRecord(id, params) {
    return request.post(`/learn/${id}`, params);
}

// 订单状态检查
export function validateCourseOrderStatus(params) {
    return request.get(`/meeting/order`, params)
}

// 课程查看
export function viewCourse(params) {
    return request.get(`/courses/view`, {params})
}


